module.exports = __webpack_public_path__ + "static/media/add.38842c8e.svg";